<template>
  <div>
    <head-nav-bar
      title="订单管理"
      :fixed="true"
      rightText="筛选"
      @click-right="onSearchClick"
    />
    <div class="mt-header-nav">
      <van-search
        placeholder=" 订单号/姓名/手机号/房号/备注"
        style="border-bottom:1px solid #f1f1f1;"
        show-action
        shape="round"
        v-model="keyword"
        @search="onSearch"
      >
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
      <van-tabs
        v-model="tabName"
        @change="onTabClick"
        :swipe-threshold="swipeThreshold"
        title-active-color="#098ae8"
      >
        <van-tab
          v-for="(item, index) in tabArr"
          :key="index"
          :title="item.title"
          :name="item.name"
        />
      </van-tabs>
      <div style="height:calc(100vh - 195px)" class="order-list">
        <DataList :api="getList" :params="params">
          <template v-slot:item="item">
            <div @click="orderDetail(item.Id)">
              <van-row>
                <van-col span="18" class="col-left">
                  <van-tag color="#199ed8" v-if="item.Status == '预订'"
                    >订
                  </van-tag>
                  <van-tag v-else-if="item.Status == '在住'" color="#00cc99"
                    >住
                  </van-tag>
                  <van-tag v-else-if="item.Status == '完成'" color="#fc0"
                    >完
                  </van-tag>
                  <van-tag v-else-if="item.Status == '暂离'" color="#d544ff"
                    >离
                  </van-tag>
                  <van-tag v-else-if="item.Status == '取消'" color="#999"
                    >取
                  </van-tag>
                  <span class="item-name">
                    {{ item.Name }}
                  </span>
                  <span
                    style="font-size: 12px;color:#999999"
                    v-if="item.ChannelName"
                  >
                    | {{ item.ChannelName }}
                  </span>
                  <span
                    style="font-size: 12px;color:#999999"
                    v-if="item.ChannelOrderNo"
                  >
                    （渠道单号：{{ item.ChannelOrderNo }}）
                  </span>
                </van-col>
                <van-col span="6" class="col-right">
                  <van-icon name="star" size="18" v-if="item.HasContacted" />
                  <van-icon
                    name="phone"
                    size="18"
                    v-if="item.Phone"
                    @click.stop="onCall(item.Phone)"
                  />
                </van-col>
              </van-row>

              <van-row class="time">
                <van-col span="16" class="col-left">
                  入离时间：{{ item.CheckInDate }} | {{ item.CheckOutDate }}
                </van-col>
                <van-col span="4" class="col-right">
                  共{{ item.RoomCount }}间
                </van-col>
                <van-col span="4" class="col-right">
                  共{{ diffDay(item) }}晚
                </van-col>
              </van-row>

              <van-row class="orderNo">
                <van-col span="12" class="col-left">
                  订单号：{{ item.OrderNo }}
                </van-col>
                <van-col span="12" class="col-right">
                  {{ item.OrderDate }}
                </van-col>
              </van-row>
            </div>
          </template>
        </DataList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchPopup from "@/components/searchPopup";
import DataList from "@/components/DataList";
import orderApi from "../../api/order.js";
import { getSelectData } from "../../api/common";
import moment from "moment";
import { tag, Search, Tab, Tabs, Row, Col, Icon, Dialog } from "vant";
export default {
  name: "OrderPage",
  components: {
    DataList,
    [Search.name]: Search,
    [tag.name]: tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  props: {},
  data() {
    return {
      getList: orderApi.getOrderPageList,
      keyword: "",
      params: {},
      tabName: "-1",
      swipeThreshold: 5,
      tabArr: [
        { name: "-1", title: "全部" },
        { name: "0", title: "预订" },
        { name: "1", title: "在住" },
        { name: "3", title: "暂离" },
        { name: "2", title: "完成" },
        { name: "4", title: "取消" },
      ],
      channelId: "",
      // customerId: "",
      bookDate: "",
      checkinDateArr: [],
      checkoutDateArr: [],
      selectData: {},
    };
  },
  model: {},
  created() {
    const AccountDate = this.user.AccountDate;
    this.checkinDateArr = [
      moment(AccountDate)
        .add(-10, "d")
        .format("YYYY-MM-DD"),
      moment(AccountDate)
        .add(10, "d")
        .format("YYYY-MM-DD"),
    ];
    this.checkoutDateArr = [
      moment(AccountDate)
        .add(-10, "d")
        .format("YYYY-MM-DD"),
      moment(AccountDate)
        .add(10, "d")
        .format("YYYY-MM-DD"),
    ];
    this.init();
  },
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  watch: {},
  methods: {
    init() {
      getSelectData({ Types: "channel,customer,pricecode,Salesman" }).then(
        res => {
          this.selectData = res.Data;
        },
      );
    },
    onSearchClick() {
      // const AccountDate = this.user.AccountDate;
      searchPopup({
        title: "筛选",
        styles: {
          width: "90%",
        },
        content: [
          {
            label: "住店日期",
            name: "CheckInDate",
            type: "dateRange",
            props: {
              defaultValue: this.checkinDateArr,
            },
          },
          {
            label: "离店日期",
            name: "CheckOutDate",
            type: "dateRange",
            props: {
              defaultValue: this.checkoutDateArr,
            },
          },
          {
            label: "订单日期",
            name: "BookDate",
            type: "datePicker",
            props: {
              defaultValue: this.bookDate,
            },
          },
          {
            label: "渠道",
            name: "ChannelId",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              defaultValue: this.channelId,
            },
            data: this.selectData.channel,
          },
          {
            label: "客户",
            name: "CustomerId",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              defaultValue: "",
              colnum: 2,
            },
            data: this.selectData.customer,
          },
          {
            label: "价类",
            name: "PriceCodeId",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              defaultValue: "",
            },
            data: this.selectData.pricecode,
          },
          {
            label: "业务员",
            name: "SalesmanId",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              colnum: 2,
              defaultValue: "",
            },
            data: this.selectData.Salesman,
          },
          {
            name: "MemberCardNo",
            type: "Input",
            props: {
              label: "会员卡号",
              placeholder: "会员卡号",
              defaultValue: "",
            },
          },
        ],
        submit: values => {
          let params = {
            CheckInDateBegin: values.CheckInDate ? values.CheckInDate[0] : "",
            CheckInDateEnd: values.CheckInDate ? values.CheckInDate[1] : "",
            CheckOutDateBegin: values.CheckOutDate
              ? values.CheckOutDate[0]
              : "",
            CheckOutDateEnd: values.CheckOutDate ? values.CheckOutDate[1] : "",
            ChannelId: values.ChannelId ? values.ChannelId : "",
            BookDate: values.BookDate ? values.BookDate : "",
            CustomerId: values.CustomerId,
            SalesmanId: values.SalesmanId,
            PriceCodeId: values.PriceCodeId,
            MemberCardNo: values.MemberCardNo,
          };
          this.checkinDateArr = [
            params.CheckInDateBegin,
            params.CheckInDateEnd,
          ];
          this.checkoutDateArr = [
            params.CheckOutDateBegin,
            params.CheckOutDateEnd,
          ];
          this.bookDate = params.BookDate;
          this.channelId = params.ChannelId;
          // this.customerId = params.CustomerId;
          this.params = { ...this.params, ...params };
        },
      });
    },
    onSearch() {
      this.params = {
        Keyword: this.keyword,
        Status: this.tabName == "-1" ? "" : this.tabName,
      };
    },
    onTabClick() {
      this.onSearch();
    },
    diffDay(item) {
      return moment(item.CheckOutDate).diff(moment(item.CheckInDate), "day");
    },
    onCall(phone) {
      // Dialog.confirm({
      //   title: "拨打订单用户电话",
      //   message: "是否拨打用户电话" + phone
      // })
      //   .then(() => {
      // on confirm
      window.location.href = "tel:" + phone;
      // })
      // .catch(() => {
      //   // on cancel
      // });
    },
    orderDetail(id) {
      this.$router.push({ name: "OrderDetail", query: { id: id } });
    },
  },
};
</script>

<style lang="less" scoped>
.col-left {
  padding: 3px 0px 3px 17px;
}
.time {
  font-size: 12px;
  color: #999999;
}
.item-name {
  font-size: 16px;
}
.orderNo {
  font-size: 12px;
  color: #cccccc;
}
.col-right {
  padding: 3px 20px 3px 0px;
  text-align: right;
}
.order-list .list-item {
  border-bottom: 3px solid #f5f5f9;
  border-bottom: 0.08rem solid #f5f5f9;
}
/deep/.van-tab--active:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 10%;
  z-index: 1;
  height: 3px;
  width: 80%;
  background-color: #ee0a24;
}
/deep/.van-tabs__line {
  display: none;
}
</style>
